/* @flow */
import Chat from 'entities/Chat';
import ChatActions from 'chat/actions/ChatActions';
import ChatMember from 'entities/ChatMember';
import * as React from 'react';
import ReportToRemindSelectModal from 'support/components/ReportToRemindSelectModal';

class ReportChatSelectModal extends React.Component<{ chat: Chat, partner: ChatMember }> {
  reportChat = (key: string, notes: ?string) => {
    const { chat, partner } = this.props;
    ChatActions.reportChat(chat.id, partner.getUuid(), key, notes);
  };

  render() {
    return (
      <ReportToRemindSelectModal
        {...this.props}
        reportee={this.props.partner.getName()}
        notesPlaceholder={'Why are you reporting ' + this.props.partner.getName() + '?'}
        onReport={this.reportChat}
      />
    );
  }
}

export default ReportChatSelectModal;
